export const dataScienceRecommendedCourses = [

    {
        id: 1,

        title: "IT SUPPORT AGENTIC AI PROJECT COURSE",

        description:
            "Build an automated IT ticketing system using multi-agent architecture, deep learning, and MLOps to classify, route, and resolve tickets with minimal human intervention.",

        linkTitle:
            "Learn AI with Real Projects",

        lessons: "10",

        duration: "11:00 hours",

        url:
            "/replace-it-help-desk-with-automated-ticketing-system-using-ai",
    },


    {
        id: 2,

        title: "LEARN ML WITH REAL PROJECTS",

        description:
            "Build real-world machine learning solutions from scratch. This hands-on course focuses on practical projects—from data prep to deployment—so you gain job-ready skills and experience with real ML applications.",

        linkTitle:
            "Learn ML with Real Projects",

        lessons: "14",

        duration: "18:00 hours",

        url:
            "/contact",
    },


    {
        id: 3,

        title:
            "LEARN ARTIFICIAL INTELLIGENCE COURSES ONLINE",

        description:
            "Learn the core concepts of AI, including search, NLP, and neural networks, and how they power real-world applications like chatbots and smart systems.",

        linkTitle:
            "Learn Artificial Intelligence COURSES ONLINE",

        lessons: "20",

        duration: "24:00 hours",

        url:
            "/ai-courses-pay-after-learn",
    },


    {
        id: 4,

        title: "LEARN PYTHON PROGRAMMING",

        description:
            "Learn Python from the ground up—perfect for beginners and intermediates aiming for careers in software development, data science, or automation.",

        linkTitle:
            "Learn Python Programming",

        lessons: "20",

        duration: "24:00 hours",

        url:
            "/python-courses-pay-after-learn",
    },


    {
        id: 5,

        title:
            "LEARN MACHINE LEARNING ONLINE",

        description:
            "Learn to build smart, predictive models using supervised and unsupervised learning with tools like Scikit-learn and TensorFlow.",

        linkTitle:
            "LEARN MACHINE LEARNING ONLINE",

        lessons: "20",

        duration: "24:00 hours",

        url:
            "/machine-learning-courses-pay-after-learn",
    },

];